document.addEventListener('DOMContentLoaded', function () {
  // Select all dropdown summary buttons (first and second-level)
  const menuSummaries = document.querySelectorAll('.header__menu-item summary');

  menuSummaries.forEach(function (summary) {
    summary.addEventListener('click', function (e) {
      e.preventDefault(); // Prevent the link from opening

      const submenu = this.nextElementSibling;

      // Close all other open submenus
      document.querySelectorAll('.header__submenu').forEach(function (menu) {
        if (menu !== submenu) {
          menu.classList.remove('open');
        }
      });

      // Toggle the clicked submenu
      submenu.classList.toggle('open');
    });
  });
});
